var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row py-3" }, [
      _c("div", { staticClass: "col-12 col-md-6 order-1 order-md-1" }, [
        _c("span", { staticClass: "btn btn-dark" }, [
          _vm._v(_vm._s(_vm.featured_post.type)),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "ml-1" }, [
          _vm._v(_vm._s(_vm.featured_post.post_date)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "post_content py-1" }, [
          _c("h5", [_vm._v(_vm._s(_vm.featured_post.title))]),
          _vm._v(" "),
          _c("div", { staticClass: "excerpt py-2" }, [
            _vm._v(_vm._s(_vm.featured_post.excerpt)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "post_link" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-primary",
                attrs: { href: _vm.featured_post.permalink, target: "_blank" },
              },
              [_vm._v("Read Full Article")]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-6 order-1 order-md-2" }, [
        _c("div", { staticClass: "img-container" }, [
          _c("img", {
            attrs: {
              src: _vm.featured_post.featured_img,
              alt: _vm.featured_post.img_alt,
            },
          }),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h4", [_vm._v("Featured Article")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }